/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Parentid1Inputs */

const en_entity_parentid1 = /** @type {(inputs: Entity_Parentid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parent ID`)
};

const de_entity_parentid1 = /** @type {(inputs: Entity_Parentid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eltern-ID`)
};

/**
* | output |
* | --- |
* | "Parent ID" |
*
* @param {Entity_Parentid1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_parentid1 = /** @type {((inputs?: Entity_Parentid1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Parentid1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_parentid1(inputs)
	return de_entity_parentid1(inputs)
});
export { entity_parentid1 as "entity_parentId" }